// Clean data file, Exporting empty arrays to ensure only live data is shown.
export const recentTransactions = [];
export const dashboardRecentTransactions = [];
export const pendingTransactions = [];
export const scheduledTransactions = [];

export const sortTransactions = (list, sortBy) => {
  const copy = [...list];
  switch (sortBy) {
    case "date-desc":
      return copy.sort((a, b) => new Date(b.date) - new Date(a.date));
    case "date-asc":
      return copy.sort((a, b) => new Date(a.date) - new Date(b.date));
    case "amount-desc":
      return copy.sort((a, b) => b.amount - a.amount);
    case "amount-asc":
      return copy.sort((a, b) => a.amount - b.amount);
    case "name-asc":
      return copy.sort((a, b) =>
        a.counterparty.localeCompare(b.counterparty)
      );
    default:
      return copy;
  }
};

export const exportToCSV = (transactions, filename = "transactions.csv") => {
  const headers = [
    "ID",
    "Type",
    "Counterparty",
    "Direction",
    "Date",
    "Amount",
    "Currency",
    "Status",
    "Category",
    "Reference",
  ];
  const rows = transactions.map((t) => [
    t.id,
    t.type,
    t.counterparty,
    t.direction,
    t.date,
    t.amount,
    t.currency,
    t.status,
    t.category || "",
    (t.reference || "").replace(/"/g, '""'),
  ]);
  const csv = [headers, ...rows]
    .map((row) => row.map((cell) => `"${cell}"`).join(","))
    .join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
